module.exports = __webpack_public_path__ + "static/media/donation-gray.0b2827a5.webp";